/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit State/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function State({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Postal/Addresses/Content/Address/Edit/Content/Fields/State",
  isInvalid,
  onChange
  
}) {
let statesValueData = fromData.useDataValue({ viewPath,
context: 'states',
})
let contactMethodAssociationPostalAddressStateValueData = fromData.useDataValue({ viewPath,
context: 'contact_method_association',
path: 'postal_address.state',
})
let contactMethodAssociationPostalAddressStateIsValidData = fromData.useDataIsValid({ viewPath,
context: 'contact_method_association',
path: 'postal_address.state',
validate: fromValidate.state,
required: true,
})
let contactMethodAssociationPostalAddressStateChangeData = fromData.useDataChange({ viewPath,
context: 'contact_method_association',
path: 'postal_address.state',
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 data="states"
 from={statesValueData}
 data="contact_method_association.postal_address.state"
 validate="/Data/validate.js state"
 required={true}
 invalid={!contactMethodAssociationPostalAddressStateIsValidData}
 value={contactMethodAssociationPostalAddressStateValueData}
 onChange={contactMethodAssociationPostalAddressStateChangeData}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="State"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}